import {Component, OnInit, signal} from '@angular/core';
import {RouterLink} from '@angular/router';
import {Company} from '../classes/company';
import {CodaltComponent} from '../codalt.component';
import {CompanyService} from '../services/company.service';
import {BreadcrumbComponent} from '../services/breadcrumb/breadcrumb.component';
import {Routenames} from '../classes/route-name.enum';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-companies-list',
    templateUrl: './companies.component.html',
    styleUrls: ['./companies.component.scss'],
    imports: [RouterLink, BreadcrumbComponent]
})
export class CompaniesComponent extends CodaltComponent implements OnInit {
    readonly companies = signal<Company[]>(null);
    showCreate: boolean = false;

    constructor(
        private companyService: CompanyService,
        private titleService: Title,
    ) {
        super();
        this.crumbs = [
            {name: 'Bedrijven', route: Routenames.companies}
        ];
        this.titleService.setTitle(`Bedrijven ${this.environment.titleAppend}`);
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.companyService.getCompanies().subscribe((companies) => {
                this.companies.set(companies);
            })
        );
    }
}
